export const authErrorCodes = [401, 419];
export const authForbiddenCode = 403;
export const badRequestCodes = 400;

export type TwoFactorPayload = {
  code: string;
};
